module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/partials/mobile-bar/mobile-bar.component.scss
// module id = ./src/app/components/partials/mobile-bar/mobile-bar.component.scss
// module chunks = main